const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: "Veuillez vous assurer que les étapes suivantes ont été effectuées avant d'initier le remplacement",
    toDoListItems: [
      "Déconnectez l'appareil à remplacer",
      "Connecter l'appareil de remplacement",
      "Configurer l'appareil de remplacement"
    ],
    install_replacement: {
      submitFirstStep: 'Récupérer les détails',
      hems_device_api_fault:
        'Si vous essayez de remplacer une charge tierce active mais que vous ne pouvez pas la voir dans la liste déroulante, veuillez recharger la page.',
      labelOldDevice: "Détails de l'ancien appareil",
      labelNewDevice: 'Détails du nouvel appareil',
      submitSecondStep: 'Confirmer le remplacement',
      warningText:
        'Si les données de l\'appareil sont incorrectes ou pour tout autre problème, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >cliquez ici</a> pour revenir en arrière.',
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: "Compteur d'énergie",
        SG_READY_GATEWAY: 'Relais SG Ready',
        MICROINVERTER: 'Micro-onduleur',
        AC_BATTERY: 'Batterie CA',
        selectDeviceType: "sélectionner le type d'appareil"
      }
    },
    replace_gateway: {
      submitFirstStep: 'Remplacer le IQ Energy Router',
      hems_device_api_fault:
        "Si vous essayez de remplacer un IQ Energy Router actif mais que vous n'arrivez pas à le voir dans la liste déroulante, veuillez recharger la page.",
      submitSecondStep: 'Remplacer le IQ Energy Router',
      labelOldDevice: "Détails de l'ancien IQ ER",
      labelNewDevice: 'Détails du nouvel IQ ER',
      warningText:
        'Si les données de l\'appareil sont incorrectes ou pour tout autre problème, <a style="color:#F37321"  href="javascript: window.parent.location.reload();" >cliquez ici</a> pour revenir en arrière.',
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Sélectionner le type de passerelle'
      }
    },
    alert: {
      footerMessage: "Si le problème persiste, veuillez contacter le service clientèle d'Enphase.",
      requestTimedOut: {
        mainMessage: 'La demande a expiré',
        subMessage: 'Veuillez réessayer plus tard'
      },
      multipleDeviceFound: {
        mainMessage: 'Remplacement non pris en charge',
        subMessageIqErEvse:
          'Plus de 1 IQ ER EVSE sont détectés sur le site. Le remplacement ne peut pas être pris en charge pour ce type de configuration de site.',
        subMessageEnergyMeter:
          "Plus de 1 compteurs d'énergie sont détectés sur le site. Le remplacement ne peut pas être pris en charge pour ce type de configuration de site.",
        subMessageSgReadyRelay:
          'Plus de 1 relais SG Ready sont détectés sur le site. Le remplacement ne peut pas être pris en charge pour ce type de configuration de site.'
      },
      iqErOffline: {
        mainMessage: 'IQ ER ne signale rien',
        subMessage: 'Veuillez vous assurer que le IQ Energy Router est alimenté et connecté à Internet.'
      },
      deviceNotOffline: {
        mainMessage: 'Ancien appareil connecté',
        subMessage:
          "Connexion d'un ancien appareil détectée. Veuillez déconnecter l'ancien appareil et recommencer le remplacement."
      },
      deviceReplacementInProgress: {
        mainMessage: 'Le remplacement du dispositif est déjà en cours pour ce type de dispositif'
      },
      deviceNotFound: {
        mainMessage: 'Nouvel appareil non détecté',
        subMessage:
          "Les détails du nouvel appareil n'ont pas été trouvés. Veuillez vous assurer que le nouvel appareil est connecté à l'internet et configuré."
      },
      invalidRmaStatusId: {
        mainMessage: 'Échec du remplacement ',
        subMessage: "Le remplacement a échoué en raison d'un statut de remplacement inconnu"
      },
      activationDuplicateSite: {
        mainMessage: 'Échec du remplacement',
        subMessage: 'Le remplacement a échoué car le nouveau IQ Energy Router est déjà actif.'
      },
      authPending: {
        mainMessage: 'Échec du remplacement',
        subMessage: "Le remplacement a échoué car le IQ Energy Router existant n'est pas encore autorisé"
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Échec du remplacement',
        subMessage: "Le remplacement a échoué car le numéro de série du IQ Energy Router saisi n'est pas valide"
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Échec du remplacement',
        subMessage:
          "Le remplacement a échoué car les appareils tiers HEMS précédemment découverts n'ont pas été trouvés"
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Échec du remplacement',
        subMessage: "Le remplacement a échoué car la IQ Gateway n'a pas encore été découverte par le IQ Energy Router"
      },
      authInitFailed: {
        mainMessage: 'Échec du remplacement',
        subMessage: "Le remplacement a échoué car l'autorisation de l'appareil n'a pas été lancée"
      },
      invalidDeviceType: {
        mainMessage: "Le type d'appareil n'est pas valide pour le remplacement",
        subMessage: "Veuillez vous assurer que le bon type d'appareil a été sélectionné avant de soumettre la demande."
      },
      invalidSite: {
        mainMessage: 'Type de site non pris en charge',
        subMessage: 'La configuration du site ne prend pas en charge ce remplacement'
      },
      invalidDevice: {
        mainMessage: "L'ancien identifiant de l'appareil semble invalide",
        subMessage: "Le remplacement n'est pas pris en charge pour ce type d'appareil"
      },
      invalidDeviceUid: {
        mainMessage: "L'ancien et le nouveau Device ID sont identiques",
        subMessage: "Le remplacement n'est pas pris en charge pour ce type d'appareil"
      },
      deviceReplacementCompleted: {
        mainMessage: 'Remplacement terminé',
        subMessage:
          "Si la validation fonctionnelle est en attente pour le nouveau dispositif, veuillez la terminer à l'aide de l'Enphase Installer Application (ITK)."
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger remplacé avec succès',
        energyMeter: 'Energy Meter remplacé avec succès',
        sgReadyRelay: 'SG Ready Relay remplacé avec succès',
        iqEnergyRouter: 'IQ Energy Router remplacé avec succès'
      },
      fetchingDeviceDetailsLoader: { subMessage: "Obtenir les détails de l'appareil" },
      initiatingReplacementLoader: { subMessage: 'Initier le remplacement' },
      replacementInprogressLoader: { subMessage: 'Remplacement en cours' }
    }
  }
};

export default DeviceReplacement;
